<template>
  <div class="container-fluid">
    <div class="row no-gutter">
      <div class="col-md-6 d-none d-md-flex bg-image"></div>
      <div class="col-md-6 bg-light">
        <div class="container-fluid">
          <div class="row no-gutter justify-content-center mt-5">
            <div class="col-md-12 bg-light">
              <div class="login d-flex align-items-center py-5">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-10 col-xl-7 mx-auto">
                      <h3 class="display-4">Hiperfarma</h3>
                      <p class="text-muted mb-4">
                        Sistema - versão: {{ VUE_APP_ROOT_VERSION }}
                      </p>
                      <b-form @submit="submit">
                        <div class="mb-3">
                          <input
                            v-model="form.login"
                            placeholder="Login"
                            required
                            class="form-control rounded-pill border-0 shadow-sm px-4"
                          />
                        </div>
                        <div class="mb-3">
                          <input
                            v-model="form.senha"
                            type="password"
                            placeholder="Senha"
                            required
                            class="form-control rounded-pill border-0 shadow-sm px-4 text-primary"
                          />
                        </div>
                        <div class="mb-3">
                          <input
                            class="px-4"
                            type="checkbox"
                            v-model="admin"
                            aria-label="Checkbox de sinalização de administrador"
                          />
                          Administrador
                        </div>
                        <div class="d-grid gap-2 mt-2">
                          <b-button
                            variant="primary"
                            type="submit"
                            class="text-uppercase mb-2 rounded-pill"
                          >
                            Login
                          </b-button>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="text-muted mb-4">Portal - versão 1.0.6</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/services/BaseService'
import { useStore } from 'vuex'
import { computed } from 'vue'
export default {
  setup() {
    const store = useStore()
    return {
      user: computed(() => store.state.user),
    }
  },
  data() {
    return {
      VUE_APP_ROOT_VERSION: process.env.VUE_APP_ROOT_VERSION,
      form: {
        login: null,
        senha: null,
      },
      admin: false,
      loading: false,
    }
  },
  created() {
    this.dbEmpresa = null
    localStorage.setItem('var_source', 'nomereduzido=hiperfarma')
    localStorage.removeItem('dbEmpresa')
    if (this.$router.currentRoute.value.path == '/login/hiper') {
      localStorage.setItem('dbEmpresa', 'admsis_hiperfarma')
      localStorage.setItem('var_source', 'nomereduzido=hiperfarma')
      this.dbEmpresa = 'admsis_hiperfarma'
    }
    if (this.$router.currentRoute.value.path == '/login/maxifarma') {
      localStorage.setItem('dbEmpresa', 'admsis_maxifarma')
      localStorage.setItem('var_source', 'atividade=CO')
      this.dbEmpresa = 'admsis_maxifarma'
    }
  },
  methods: {
    async submit() {
      var localStorageAdmin = this.admin
      try {
        localStorage.setItem('admin', localStorageAdmin)
        const endpoint = this.admin ? 'authLogin' : 'authLoginFarmacia'
        var http = new service(endpoint)
        await http.create(this.form).then((resp) => {
          if (resp.data.success == true) {
            if (!this.admin) {
              const classe = parseInt(resp.data.data[0].classe)
              if (classe === 3) {
                this.$toast.error(
                  'Farmácia não autorizada! Contacte a administração.',
                )
                return
              }
            }

            this.$store.commit({
              type: 'setUser',
              value: resp.data.data[0],
            })

            localStorage.setItem('token', resp.data.token)
            this.$toast.success('Logado com Sucesso!')
            this.$router.push({
              name: 'Campanhas',
            })
          } else {
            this.$toast.error(resp.data.message)
          }
        })
      } catch (e) {
        if (e.response.status != 401) {
          this.$toast.error(e.response.data.message)
        }
      }
    },
    async refreshToken(user) {
      try {
        var http = new service('authLogin')
        await http.create(user).then((resp) => {
          if (resp.data.success == true) {
            localStorage.setItem('token', resp.data.token)
          } else {
            this.$router.push({
              name: 'Login',
            })
          }
        })
      } catch (e) {
        this.$router.push({
          name: 'Login',
        })
      }
    },
  },
}
</script>
<style scoped>
.login,
.image {
  min-height: 100vh !important;
}

.bg-image {
  background-image: url('../../src/assets/logo.jpg');
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.bg-light {
  background-color: #fff !important;
}
</style>
